module.exports = __webpack_public_path__ + "static/media/homeaway-logo-icon.1486e727.png";